import Page from '../Page';
import {useEffect} from 'preact/hooks';
import {useLocation} from 'preact-iso';
import {collectionPath} from '../productRoutes';

export default function CollectionLinkPage() {
  const location = useLocation();
  const collectionId = location.query.id || location.query['ids[]'];

  useEffect(() => {
    if (collectionId) location.route(collectionPath(collectionId), true);
  }, [location, collectionId]);

  return (
    <Page heading="Collection configuration">
      {collectionId
        ? <s-spinner accessibilityLabel="Opening collection configuration" />
        : <s-banner tone="critical">Shopify did not provide a collection ID for this action.</s-banner>}
    </Page>
  );
}
